import { FC } from 'react';
import { setNewVersionModalOpen } from 'store/actions/newVersionModal';
import { Dispatch } from 'redux';
import { RootState } from 'store/types';
import { connect } from 'react-redux';
import './filters.scss';
import AppModal from 'components/modal';
import { CHANGE_MODAL_STATE } from 'store/reducers/newVersionModal/modal/types';
import store from 'store';

interface DispatchProps {
  setNewVersionModalOpen: (isOpen: boolean) => void;
};

interface OwnProps {};

interface StateProps {
  modalOpen: boolean; 
}

type NewVersionModalProps = DispatchProps & OwnProps & StateProps;

const NewVersionModal: FC<NewVersionModalProps> = ({ modalOpen }: NewVersionModalProps) => {
return (
  <AppModal
    open={modalOpen}
    toggle={()=>{}}
    title="New version is available"
    cancelButton={{
      color: 'none',
    }}
    saveButton={{
      text: 'Reload',
      color: 'primary',
      onClick: ()=>{
        store.dispatch({type: CHANGE_MODAL_STATE, isOpen: false});
        window.location.reload();
      }
    }}
    isDisableCloseBtn={true}
    zIndex={99999}
  >
    <div>A new app version is available. Please reload the page to continue</div>
  </AppModal>
  )
};

const mapStateToProps = (state: RootState): StateProps => ({
  modalOpen: state.modal.modal.isOpen
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  setNewVersionModalOpen: (isOpen: boolean) => dispatch(setNewVersionModalOpen(isOpen))
});

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(NewVersionModal);
